<!-- 库存移库 -->
<template>
   <div>
      <subComponents ref="showSelectData"></subComponents>
      <div>
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs v-if="tabForm" :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'"
                  :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }"
                  @tabHeight="(val) => { mxHeight = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form class="baseForm" id="mainInfo" label-width="100px" :model="sendDataInfo"
                              ref="sendDataInfo" size="mini" :show-message="false" :inline-message="false">
                              <el-row v-if="dataActionBox.actionType != 2">
                                 <el-form-item v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                    :label="formOneValue.showField" :prop="formOneValue.entityField"
                                    :rules="formOneValue.isRequired == 1 ? [{ required: true, message: formOneValue.showField + '不能为空', trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 申请日期 -->
                                    <df-date class="form_codition"
                                       :isdisabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2"
                                       :isShowLong="false" v-if="formOneValue.fieldType == 'date'"
                                       v-model="sendDataInfo[formOneValue.entityField]"></df-date>

                                    <!-- 门店 -->
                                    <el-tooltip v-else-if="formOneValue.entityField == 'storeId'" class="item"
                                       :disabled="sendDataInfo.storeName == null || sendDataInfo.storeName == '' ? true : false || sendDataInfo.storeName.length <= 9"
                                       effect="dark" :content="sendDataInfo.storeName" placement="bottom-start">
                                       <el-input class="form_codition" clearable
                                          @keyup.enter.native="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                          :disabled="formOneValue.isChange == 0" v-model="sendDataInfo.storeName"
                                          :maxlength="$store.state.inputLength">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                       :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                       effect="dark" :content="sendDataInfo[formOneValue.entityField]"
                                       placement="bottom-start">
                                       <el-input class="form_codition" clearable
                                          @keyup.enter.native="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                          :disabled="formOneValue.isChange == 0"
                                          v-model="sendDataInfo[formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength">
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, 0, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <!-- 申请原因 -->
                                    <el-input class="form_codition" v-else type="text"
                                       v-model.trim="sendDataInfo[formOneValue.entityField]"
                                       :maxlength="$store.state.inputLength"
                                       :disabled="formOneValue.isChange == 0"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType == 2">
                                 <el-form-item :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1"
                                    v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)"
                                       v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                          sendDataInfo[formOneValue.entityField] }}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                       {{ $common.getIsGsp(formOneValue.formatterContent,
                                          sendDataInfo[formOneValue.entityField]) }}
                                    </span>


                                    <span v-else-if="formOneValue.entityField == 'storeId'">{{
                                       sendDataInfo['storeName'] }}</span>
                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <!-- 明细 -->
                           <el-form :inline="true" size="mini">
                              <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                 <el-button type="primary" size="mini" @click="addDetails">新增
                                 </el-button>
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                              </div>
                              <el-table size="mini" ref="mxTableRef" id="mxTable" :data="sendDataInfo.detailList"
                                 :height="mxHeight" @row-dblclick="openDateilsBox" border style="width: 100%">
                                 <el-table-column label="选择操作" width="80">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" width="180" :prop="formOneValue.entityField"
                                    :label="formOneValue.showField" v-for="(formOneValue, formOneKey) in mxForm"
                                    :key="formOneKey" v-if="formOneValue.isShow == 1">
                                    <template slot-scope="scope">
                                       <!-- 商品 -->
                                       <el-input :ref="formOneValue.entityField"
                                          v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.detailList[scope.$index].bgmName"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          clearable>
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>
                                       <span v-else-if="formOneValue.entityField == 'prodate'">{{
                                          $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                       }}
                                       </span>
                                       <span v-else-if="formOneValue.entityField == 'expidate'">{{
                                          $common.getLocalTime(sendDataInfo.detailList[scope.$index][formOneValue.entityField])
                                       }}
                                       </span>
                                       <el-input :ref="formOneValue.entityField" :min="0"
                                          v-else-if="formOneValue.entityField == 'splitNum' && dataActionBox.actionType != 2"
                                          type="number"
                                          v-model.trim="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          :maxlength="$store.state.inputLength"
                                          @input="calculatePrice(1, scope.$index)">
                                       </el-input>
                                       <el-input :ref="formOneValue.entityField"
                                          v-else-if="formOneValue.fieldType == 'search' && dataActionBox.actionType != 2"
                                          v-model.number="sendDataInfo.detailList[scope.$index][formOneValue.entityField]"
                                          @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                          clearable>
                                          <el-button
                                             @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField)"
                                             slot="append" icon="el-icon-search"></el-button>
                                       </el-input>

                                       <span v-else>{{
                                          sendDataInfo.detailList[scope.$index][formOneValue.entityField] }}</span>
                                    </template>
                                 </el-table-column>
                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foot">
               <div>

                  <el-button type="primary" @click="initActionBox('sendDataInfo')"
                     v-if="dataActionBox.actionType != 2">取消</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 0">保存</el-button>
                  <el-button type="primary" @click="sendDataAction('sendDataInfo')"
                     v-if="dataActionBox.actionType == 1">保存</el-button>
               </div>
               <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline" v-if="footForm">
                  <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                     <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                  </el-form-item>
               </el-form>
            </div>
         </div>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
         :modal-append-to-body='true' :append-to-body="true">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel"
            @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
   </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import NP from "number-precision";
export default {
   name: "shopSplitAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         selectDataTable: false,
         sendDataInfo: {
            ovmAppdate: "", //申请日期
            storeName: "",
            storeId: "",
            totalMoney: 0, //总金额
            totalNumber: 0, //总数量
            //   totalCbmoney: 0, //总成本金额
            totalCount: 0, //总条目数
            detailList: [],
         },
         stdId: "",//门店id
         detaislDataInfo: {},
         selectedDataIndex: 0,
         storageRoomList: [],
         selectedDetails: [],
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         DialogVisible: false,
         seTitle: "",
         seWidth: "",
         exWidth: "",
         parentSearchData: {
         },
         mxHeight: 0,
         tabForm: [],
         mxForm: [],
         footForm: [],
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.storeName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.sendDataInfo.storeId = "";
            }
         },
         deep: true,
      },

      "sendDataInfo.detailList": {
         handler: function (newValue, oldValue) {
            // 计算总金额和总数量，但不在监听器中修改detailList本身
         
            this.sendDataInfo.totalNumber = 0; // 总数量
            this.sendDataInfo.totalMoney = 0; // 总金额
            // 只计算总金额，不修改detailList中的数据
            newValue.forEach((item, keys) => {
               if (Number(item.splitNum) < 0) {
                  this.sendDataInfo.detailList[keys].splitNum = 0;
               }
               this.$set(item, 'splitNum', this.$common.updataNum('splitNum', item).splitNum)

               if (item.splitNum > item.num) {
                  item.splitNum = item.num;
                  return this.$message({
                     message: "拆分数量不能大于库存数量",
                     type: "warning",
                  });
               }
               // 总数量
               this.sendDataInfo.totalNumber = NP.plus(
                  this.sendDataInfo.totalNumber,
                  item.splitNum
               );
               // 总金额
               this.sendDataInfo["detailList"][keys].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.psprice, item.splitNum)
                  );
               this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
                  3,
                  NP.plus(
                     this.sendDataInfo.totalMoney,
                     this.sendDataInfo["detailList"][keys].psmoney 
                  )
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 计算价格
      calculatePrice(cate, index) {
         var info = this.sendDataInfo.detailList[index];
         if (info.splitNum <= 0) {
            this.$message({
               message: "请先填写拆分数量",
               type: "error",
            });
            return false;
         }
         switch (cate) {
            case 1: //数量
               // this.sendDataInfo.detailList[index].baPsmoney = this.$common.getDecimalInfo(3, NP.times(info.baPsprice, info.splitNum))
               break;
            case 2: // 价格
               // this.sendDataInfo.detailList[index].baPsmoney = this.$common.getDecimalInfo(3, NP.times(info.baPsprice, info.splitNum))
               break;
            default:
               break;
         }
      },
      //新增明细
      addDetails() {
         var flag = false;
         if (this.sendDataInfo.storeId == "") {
            this.$message.warning("请先选择门店");
            return;
         }
         if (this.sendDataInfo.detailList.length > 0) {
            this.sendDataInfo.detailList.forEach((item) => {
               if (item.bgmId == "") {
                  flag = true;
                  this.$nextTick(() => {
                     this.selectedDataIndex = Number(
                        this.sendDataInfo.detailList.length - 1
                     );

                     let refsElTable = this.$refs.mxTableRef;
                     refsElTable.clearSelection();
                     refsElTable.toggleRowSelection(
                        this.sendDataInfo.detailList[
                        this.selectedDataIndex
                        ]
                     );
                  });
               }
            });
         }
         if (flag) {
            return;
         }
         this.sendDataInfo.detailList.push({});
         var index = this.sendDataInfo.detailList.length - 1;
         for (const key in this.detaislDataInfo) {
            this.$set(
               this.sendDataInfo.detailList[index],
               key,
               this.detaislDataInfo[key]
            );
         }
         this.$nextTick(() => {
            this.selectedDataIndex = Number(
               this.sendDataInfo.detailList.length - 1
            );
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
               this.sendDataInfo.detailList[this.selectedDataIndex]
            );
         });
      },

      openDateilsBox(row, column, event) {
         this.editDateilsIndex = row.index;
         this.detailList = JSON.parse(JSON.stringify(row));
      },
      changeInputModel(val) {
         this.DialogVisible = false;
         if (val && (val != "" || val != undefined)) {
            if (this.seType == "storeId") {
               this.sendDataInfo.storeName = val.storeName;
               this.sendDataInfo.storeId = val.storeId;
               this.sendDataInfo.stId = val.stId;
               this.stdId = val.stId;
            } else if (this.seType == "bgmName") {
               for (let fkey in this.sendDataInfo.detailList[
                  this.seIndex
               ]) {
                  for (let vkey in val) {
                     if (fkey == vkey) {
                        this.$set(
                           this.sendDataInfo.detailList[this.seIndex],
                           fkey,
                           val[fkey]
                        );
                     }
                  }
               }
               this.sendDataInfo.detailList[this.seIndex].lotno = val.lotno || '';
               // 确保初始化金额为0而不是undefined
               this.$set(
                  this.sendDataInfo.detailList[this.seIndex],
                  'psmoney',
                  val.psmoney || 0
               );
               this.tableNextFocus("splitNum", this.seIndex);
            }


         }
      },
      // 赋值字段
      paramValue(val) {

         let arr = this.sField.split(",");
         arr.forEach((item) => {
            if (item == "stId") {

               this.stdId = val[item];
            }


            else {
               this.sendDataInfo.detailList[this.seIndex][item] = val[item];
            }
         });
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         this.seIndex = index;
         if (field == "keydown") {
            if (this.sendDataInfo.detailList[index + 1] != undefined) {
               this.$refs["bgmName"][index + 1].focus();
               this.selectedDetailsIndex = index + 1;
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef;
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(
                     this.sendDataInfo.detailList[this.selectedDetailsIndex]
                  );
               });
               return;
            }
            this.addDetails("sendDataInfo");
            return;
         }
         this.$refs[field][index].focus();
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type, sField) {
         if (type == "bgmName") {
            this.parentSearchData.stId = this.stdId;
         }
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex = index;
         this.seType = type;
         this.sField = sField;


      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },

      initActionBox(sendDataInfo) {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$emit("drawerCancel", 0);
               this.init();
               this.$refs.sendDataInfo.resetFields();
            })
            .catch(() => {
               // this.$message({
               //     type: 'info',
               //     message: '取消关闭'
               // });
            });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.ovmAppdate = this.$moment().valueOf(); //申请日期
         this.sendDataInfo.totalCount = 0; //总条目数
         this.sendDataInfo.totalMoney = 0; // 总金额
         this.sendDataInfo.totalNumber = 0; // 总数量
         //   this.sendDataInfo.totalCbmoney = 0; // 总成本金额
         this.sendDataInfo.detailList = [];
      },
      async isShowData(name, value) {
         this.sendDataInfo[name] = value;
      },

      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.filterMainField();
         this.init();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            this.sendDataInfo.storeName = dataInfo.storeName;
            this.sendDataInfo.storeId = dataInfo.storeId;
            console.log(JSON.parse(JSON.stringify(oldData)), "oldData");
            console.log(dataInfo, "dataInfo");
            console.log(this.sendDataInfo, "this.sendDataInfo");

            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            console.log(JSON.parse(JSON.stringify(oldData)), "oldData");
            this.sendDataInfo.storeName = dataInfo.storeName;
            this.sendDataInfo.storeId = dataInfo.storeId;
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key]);
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight();
               } else {
                  this.mxHeight = this.$common.getHeight();
               }
            }, 16.7);
         });
      },
      sendDataAction(sendDataInfo) {
         this.$refs.sendDataInfo.validate((valid) => {
            if (valid) {
               this.sub();
            } else {
               return false;
            }
         });
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         console.log(sendData, "sendData");
         if (this.dataActionBox.actionType == 0) {
            var responseData = await this.$http.splitAdd(sendData);
         } else {
            var responseData = await this.$http.splitModifyMaster(sendData);
         }
         console.log(responseData, "responseData");

         if (responseData.status == 200) {
            this.init();
            this.$message.success("操作成功");
            this.$emit("drawerCancel", 1);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      deleteDetails(index) {
         if (this.sendDataInfo.detailList.length > 0) {
            this.sendDataInfo.detailList.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = [];
         this.formDataList.forEach((item) => {
            if (item.jciType == 1) {
               mainFormList.push(item);
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform));
               this.mxForm.forEach((item1) => {
                  if (item1.fieldType == "number") {
                     this.$set(this.detaislDataInfo, item1.entityField, 0);
                  } else if (item1.fieldType == "search" && item1.setField) {
                     var arr = item1.setField.split(",");
                     arr.forEach((item2) => {
                        this.$set(this.detaislDataInfo, item2, "");
                     });
                  } else {
                     this.$set(this.detaislDataInfo, item1.entityField, "");
                  }
               });
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
            }
         });
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key));
            this.tabForm[i].jurconfigform = [];
            for (let index = 0; index < key.jurconfigform.length; index++) {
               if (key.jurconfigform[index].isShow == 1)
                  this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
            }
         });
         var arr = [{ entityField: "detailList" }];
         var obj = this.$common.filterMainFields(
            this.formDataList,
            arr,
            mainFormList[0]
         );
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key]);
         }
         this.$set(this.sendDataInfo, "ovmAppdate", this.$moment().valueOf());
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.$nextTick(() => {
         this.openBox();

      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

#mxTable .el-form-item--mini.el-form-item,
#mxTable .el-form-item--small.el-form-item {
   margin-bottom: 0;
}
</style>